import { call, put, select, takeEvery } from 'typed-redux-saga';

import { FEEDBACK_COUNT_STORAGE_KEY } from '../../../../shared/constants';
import { NOTIFICATIONS_MAP, notify } from '../../../../shared/features/notifications/ps-notifications';
import { createLogger } from '../../../../shared/helpers/loggerFacade';
import { countMetrika } from '../../../../shared/helpers/metrika';
import { cloudApi } from '../../../../shared/helpers/transport';
import { selectStatsEventBaseData } from '../../selectors';
import { NotificationId } from '../../types';
import { CONFERENCE_ID_KEY, MESSAGE_KEY, REASONS_KEY } from './constants';
import { reportAProblemFormWasShownAction, sendReportAProblemAction } from './slice';

const logger = createLogger('reportAProblem');

function* countReportAProblemMetrica(command: string) {
    yield* call(countMetrika, 'meeting_screen', 'problem_button', command);
}

function* reportAProblemFormWasShownSaga() {
    yield* call(countReportAProblemMetrica, 'report_form_show');

    const eventData = yield* select(selectStatsEventBaseData);

    try {
        yield* call([cloudApi, cloudApi.reportAProblemFormWasShown], eventData);
    } catch (error) {
        logger.error(error, { method: 'reportAProblemFormWasShownSaga' });
    }
}

function* sendReportAProblemSaga({ payload }: ReturnType<typeof sendReportAProblemAction>) {
    const eventData = yield* select(selectStatsEventBaseData);

    try {
        yield* call([cloudApi, cloudApi.sendReportAProblem], {
            ...eventData,
            ...payload,
        });

        localStorage.removeItem(REASONS_KEY);
        localStorage.removeItem(MESSAGE_KEY);
        localStorage.removeItem(CONFERENCE_ID_KEY);

        localStorage.setItem(FEEDBACK_COUNT_STORAGE_KEY, '1');

        yield* put(notify(NOTIFICATIONS_MAP[NotificationId.REPORT_A_PROBLEM_SUCCESS]()));

        if (payload.reasons.length === 0 && payload.comment === '') {
            yield* call(countReportAProblemMetrica, 'empty_form_sent');
        } else {
            yield* call(countReportAProblemMetrica, 'send_success');
        }

        yield* call(countReportAProblemMetrica, 'notification_show');
    } catch (error) {
        logger.error(error, { method: 'sendReportAProblemSaga' });

        yield* put(notify(NOTIFICATIONS_MAP[NotificationId.REPORT_A_PROBLEM_FAILED]()));

        yield* call(countReportAProblemMetrica, 'send_error');
    }
}

export function* reportAProblemSagas() {
    yield* takeEvery(reportAProblemFormWasShownAction, reportAProblemFormWasShownSaga);
    yield* takeEvery(sendReportAProblemAction, sendReportAProblemSaga);
}
